import type { FormEventHandler } from 'react'
import { Controller, type Control } from 'react-hook-form'
// import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded'
// import Alert from '@mui/joy/Alert'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Option from '@mui/joy/Option'
import Select from '@mui/joy/Select'
// import ToggleButtonGroup from '@mui/joy/ToggleButtonGroup'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import FloatingLabelInput from '@/components/checkout/floating-label-input'
import {
    getCheckoutValidationMessages,
    validateVehicleNumberPlate,
    type CheckoutFormValues,
} from '@/components/checkout/page/controller'
import { VehicleEntryMode, type UserVehicle } from '@/types'
import {
    getSavedCarSelectionValue,
    type CheckoutVehicleSelection,
} from './utils'

function getFieldErrorMessage(error?: { message?: string }): string | null {
    return typeof error?.message === 'string' ? error.message : null
}

function ValidationError({ message }: { message: string | null }) {
    if (!message) {
        return null
    }

    return (
        <Typography level="body-xs" color="danger" sx={{ mt: 0.5 }}>
            {message}
        </Typography>
    )
}

type CheckoutVehicleInfoFormProps = {
    control: Control<CheckoutFormValues>
    currentUserCars: UserVehicle[]
    vehicleEntryMode: VehicleEntryMode
    shouldShowCustomInputs: boolean
    selectedSavedCar: UserVehicle | null
    hideActions?: boolean
    requestInProgress?: boolean
    errorMessage?: string | null
    vehicleSelectLabelId: string
    onCancel: () => void
    onClear: () => void
    onSubmit: FormEventHandler<HTMLFormElement>
    onSaveCurrentSelection: () => void
    onVehicleEntryModeChange: (mode: VehicleEntryMode) => void
}

export default function CheckoutVehicleInfoForm({
    control,
    currentUserCars,
    vehicleEntryMode,
    shouldShowCustomInputs,
    selectedSavedCar,
    hideActions = false,
    requestInProgress = false,
    errorMessage,
    vehicleSelectLabelId,
    onCancel,
    onClear,
    onSubmit,
    onSaveCurrentSelection,
    // onVehicleEntryModeChange,
}: CheckoutVehicleInfoFormProps) {
    const { t } = useTranslation()
    const validationMessages = getCheckoutValidationMessages(t)
    const hasSavedCars = currentUserCars.length > 0

    return (
        <form
            onSubmit={onSubmit}
            style={{ marginBottom: 0 }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    pt: 1.5,
                }}
            >
                {/* <ToggleButtonGroup
                    value={vehicleEntryMode}
                    onChange={(_event, nextMode) => {
                        if (nextMode) {
                            onVehicleEntryModeChange(nextMode)
                        }
                    }}
                    spacing={0.5}
                    aria-label="vehicle entry timing"
                    sx={{
                        width: '100%',
                        mt: 0.5,
                        p: 0.5,
                        borderRadius: 12,
                        backgroundColor: '#f1f1f1',
                        '--ButtonGroup-separatorSize': '0px',
                        '--ButtonGroup-separatorColor': 'transparent',
                        '--Button-radius': '12px',
                        '--Button-gap': '0.5rem',
                    }}
                >
                    <Button
                        type="button"
                        value="now"
                        variant="plain"
                        aria-label={t('checkout.vehicleInfo.addNow')}
                        sx={{
                            flex: 1,
                            fontWeight: 600,
                            borderRadius: 10,
                            border: 0,
                            color: vehicleEntryMode === VehicleEntryMode.now ? '#4a4a4a' : '#9f9f9f',
                            backgroundColor:
                                vehicleEntryMode === VehicleEntryMode.now ? '#ffffff' : 'transparent',
                            boxShadow:
                                vehicleEntryMode === VehicleEntryMode.now
                                    ? '0 1px 2px rgba(0, 0, 0, 0.06)'
                                    : 'none',
                            '&:hover': {
                                backgroundColor:
                                    vehicleEntryMode === VehicleEntryMode.now ? '#ffffff' : 'transparent',
                            },
                            '&:active': {
                                backgroundColor:
                                    vehicleEntryMode === VehicleEntryMode.now ? '#ffffff' : 'transparent',
                            },
                            '&[aria-pressed="true"]': {
                                backgroundColor: '#ffffff',
                                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
                                color: '#4a4a4a',
                            },
                        }}
                    >
                        {t('checkout.vehicleInfo.addNow')}
                    </Button>
                    <Button
                        type="button"
                        value="later"
                        variant="plain"
                        aria-label={t('checkout.vehicleInfo.addLater')}
                        sx={{
                            flex: 1,
                            fontWeight: 600,
                            borderRadius: 10,
                            border: 0,
                            color: vehicleEntryMode === VehicleEntryMode.later ? '#4a4a4a' : '#9f9f9f',
                            backgroundColor:
                                vehicleEntryMode === VehicleEntryMode.later ? '#ffffff' : 'transparent',
                            boxShadow:
                                vehicleEntryMode === VehicleEntryMode.later
                                    ? '0 1px 2px rgba(0, 0, 0, 0.06)'
                                    : 'none',
                            '&:hover': {
                                backgroundColor:
                                    vehicleEntryMode === VehicleEntryMode.later ? '#ffffff' : 'transparent',
                            },
                            '&:active': {
                                backgroundColor:
                                    vehicleEntryMode === VehicleEntryMode.later ? '#ffffff' : 'transparent',
                            },
                            '&[aria-pressed="true"]': {
                                backgroundColor: '#ffffff',
                                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
                                color: '#4a4a4a',
                            },
                        }}
                    >
                        {t('checkout.vehicleInfo.addLater')}
                    </Button>
                </ToggleButtonGroup> */}
                {/* {vehicleEntryMode === VehicleEntryMode.now ? ( */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {hasSavedCars ? (
                            <Box sx={{ position: 'relative' }}>
                                <Typography
                                    id={vehicleSelectLabelId}
                                    component="label"
                                    htmlFor="checkout-vehicle-select-button"
                                    sx={theme => ({
                                        position: 'absolute',
                                        lineHeight: 1,
                                        top: '0.5rem',
                                        left: '14px',
                                        fontSize: '0.75rem',
                                        color: theme.vars.palette.text.tertiary,
                                        fontWeight: theme.vars.fontWeight.md,
                                        pointerEvents: 'none',
                                        zIndex: 1,
                                    })}
                                >
                                    {t('checkout.vehicleInfo.savedCarsLabel')}
                                </Typography>
                                <Controller
                                    name="vehicle_selection"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                        <Box>
                                            <Select
                                                value={field.value}
                                                onChange={(_event, value) => {
                                                    if (value) {
                                                        field.onChange(value as CheckoutVehicleSelection)
                                                    }
                                                }}
                                                slotProps={{
                                                    button: {
                                                        id: 'checkout-vehicle-select-button',
                                                        'aria-labelledby': `${vehicleSelectLabelId} checkout-vehicle-select-button`,
                                                        sx: {
                                                            width: '100%',
                                                            fontWeight: 'inherit',
                                                            justifyContent: 'flex-start',
                                                            minHeight: '56px',
                                                            pt: '1rem',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            '&:focus': {
                                                                boxShadow: 'none',
                                                                outline: 'none',
                                                            },
                                                            '&:hover': {
                                                                color: 'inherit',
                                                            },
                                                        },
                                                    },
                                                    listbox: {
                                                        sx: {
                                                            minWidth: 0,
                                                            width: '100%',
                                                            overflowX: 'hidden',
                                                        },
                                                    },
                                                }}
                                                sx={{
                                                    '--Select-minHeight': '56px',
                                                    '--Select-radius': '6px',
                                                    width: '100%',
                                                    minWidth: 0,
                                                }}
                                            >
                                                {currentUserCars.map(car => (
                                                    <Option
                                                        key={car.id}
                                                        value={getSavedCarSelectionValue(car.id)}
                                                        sx={{
                                                            display: 'block',
                                                            maxWidth: '100%',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}
                                                    >
                                                        {[car.number_plate.trim(), car.name.trim(), car.color.trim()]
                                                            .filter(Boolean)
                                                            .join(' · ')}
                                                    </Option>
                                                ))}
                                                <Option value="custom">
                                                    {t('checkout.vehicleInfo.customOption')}
                                                </Option>
                                            </Select>
                                            <ValidationError message={getFieldErrorMessage(fieldState.error)} />
                                        </Box>
                                    )}
                                />
                            </Box>
                        ) : null}
                        {shouldShowCustomInputs ? (
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        sm: 'repeat(2, minmax(0, 1fr))',
                                    },
                                    gap: 2,
                                }}
                            >
                                <Controller
                                    name="number_plate"
                                    control={control}
                                    rules={{
                                        validate: value => validateVehicleNumberPlate(value, validationMessages),
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Box>
                                            <FloatingLabelInput
                                                {...field}
                                                label={t('checkout.vehicleInfo.numberPlate')}
                                                required
                                                error={!!fieldState.error}
                                            />
                                            <ValidationError message={getFieldErrorMessage(fieldState.error)} />
                                        </Box>
                                    )}
                                />
                                <Controller
                                    name="car_color"
                                    control={control}
                                    render={({ field }) => (
                                        <Box>
                                            <FloatingLabelInput
                                                {...field}
                                                label={t('checkout.vehicleInfo.carColor')}
                                            />
                                        </Box>
                                    )}
                                />
                            </Box>
                        ) : null}
                    </Box>
                {/* ) : (
                    <Alert
                        variant="soft"
                        color="neutral"
                        startDecorator={
                            <PhoneIphoneRoundedIcon
                                sx={{
                                    color: '#6e6e6e',
                                    fontSize: '16px',
                                }}
                            />
                        }
                        sx={{
                            mx: 'auto',
                            maxWidth: '28rem',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            backgroundColor: 'var(--joy-palette-neutral-50)',
                            borderRadius: 10,
                            '& .MuiAlert-startDecorator': {
                                alignSelf: 'center',
                            },
                        }}
                    >
                        <Typography level="body-sm">
                            {t('checkout.vehicleInfo.addLaterDescription')}
                        </Typography>
                    </Alert>
                )} */}
                {errorMessage ? (
                    <Typography level="body-sm" color="danger">
                        {errorMessage}
                    </Typography>
                ) : null}
                {!hideActions ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            pt: 1,
                        }}
                    >
                        <Button
                            type="button"
                            variant="plain"
                            onClick={onClear}
                            disabled={requestInProgress}
                        >
                            {t('checkout.vehicleInfo.clear')}
                        </Button>
                        <Box sx={{
                            display: 'flex',
                            gap: 1,
                        }}>
                            <Button
                                type="button"
                                variant="plain"
                                onClick={onCancel}
                                disabled={requestInProgress}
                            >
                                {t('checkout.vehicleInfo.cancel')}
                            </Button>
                            <Button
                                type={
                                    vehicleEntryMode === VehicleEntryMode.now && shouldShowCustomInputs
                                        ? 'submit'
                                        : 'button'
                                }
                                variant="solid"
                                loading={requestInProgress}
                                onClick={
                                    vehicleEntryMode === VehicleEntryMode.now && shouldShowCustomInputs
                                        ? undefined
                                        : onSaveCurrentSelection
                                }
                                disabled={
                                    vehicleEntryMode === VehicleEntryMode.now
                                    && hasSavedCars
                                    && !shouldShowCustomInputs
                                    && !selectedSavedCar
                                }
                            >
                                {t('checkout.vehicleInfo.save')}
                            </Button>
                        </Box>
                    </Box>
                ) : null}
            </Box>
        </form>
    )
}
